import { AddIconButton } from '@library/components/buttons';
import { PageTitle } from '@library/components/PageTitle';
import { PromotionsList } from '@bo-components/promotions/PromotionsList';
import { useNavigate } from 'react-router-dom';

export const Promotions = () => {
  const navigate = useNavigate();

  const handleCreatePromotion = () => {
    navigate('/promotions/new');
  };

  return (
    <div className="flex w-auto flex-col gap-6 px-6 pb-2 pt-3">
      <div className="flex justify-between">
        <PageTitle title="Promotions" />
        <AddIconButton
          className="bg-stankonia-100 hover:bg-stankonia-100 text-soClean-100 !size-auto px-2 py-1"
          label="Create promotion"
          onClick={handleCreatePromotion}
        />
      </div>

      <PromotionsList />
    </div>
  );
};
